import { DI } from '@intigral/constant/config/DIContainer';
import { container } from '../../../DataDomain';
import { IEntitlementRepository } from '../../repositories/interfaces/iEntitlementRepository';
import { SVODEntitlement, TVODEntitlement } from '../../../entity/interface/iEntitlements';

export interface IAllowedChanelsUseCase {
    execute(
        apiKey: string,
        username: string,
        language: string,
        device: string,
        country: string,
        token: string,
        identityToken: string
    ): Promise<{
        entitledSvods: SVODEntitlement[];
        entitledTvods: TVODEntitlement[];
    }>;
}

export class GetAlowedChanelsUseCase implements IAllowedChanelsUseCase {
    // Lazy getter for repository to avoid circular dependencies
    private get getAllowedChanelsRepository(): IEntitlementRepository {
        return container.resolve<IEntitlementRepository>(DI.REPOSITORIES.IEntitlementRepository);
    }

    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }
    async execute(
        apiKey: string,
        username: string,
        language: string,
        device: string,
        country: string,
        token: string,
        identityToken: string
    ): Promise<
        | {
              entitledSvods: SVODEntitlement[];
              entitledTvods: TVODEntitlement[];
          }
        | any
    > {
        const response = await this.getAllowedChanelsRepository.allowedChannels(
            apiKey,
            username,
            language,
            device,
            country,
            token,
            identityToken
        );
        return response.data.ids || [];
    }
}
